import renderProps from '../renderProps';

export default renderProps(docs => ({ docs }), {
  callee: '<Find>',
  example: '<Find db={name|options} ... />'
});
